import { AutoComplete, Input, Tooltip, Breadcrumb, message, Select, Checkbox, Alert } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, AscRed, DescGrey, CloseIconSearch, PUrgent, PHigh, PMedium, PLow, ApproveIcon, RejectedIcon, WaitApproveIcon } from "../../../asset";
import style from "./GromartOrderRequestList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { onChanged } from "../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../component/select/SelectOption";
import SecondaryButton from "../../../component/button/SecondaryButton";
import ModalStartEndTrip from "../../../component/modal/ModalStartEndTrip";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";

const GromartOrderRequestList = (props) => {
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const location = useLocation()
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] =useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);
  const [load, setLoad] = useState(false)
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState(); 
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const [isChecked, setIsChecked] = useState(false);
  // const [listData, setListData] = useState([]);
  const [dataCheck, setDataCheck] = useState([]);
    const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [trip, setTrip] = useState([]);
  const [listTrip, srtListTrip] = useState([]);
  // const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");
  const [message2, setMessage2] =useState("")
  
  const dispatch = useDispatch()
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_ORDER_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGetParam(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}

  const fetchData = async (data, pages) => {
    setLoad(true)
    console.log("fil", filter);
    console.log("data", data);
    let id = 1;
    let res2 = await doGetParam(
      `/depot-list-filter?page=1&limit=10&${param}`,
      token
    );
    
    if(!res2?.data?.payload?.data){
      setLoad(false)
    }else{
    let res = await doGet(
      `/gromart-order?page=${pages ? pages :page}&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", customer_name lk " + filter : data ? ", customer_name lk "+ data : ""}&${param}`,
      token)
    let init = await doGet(
      `/gromart-order/initiate?page=${pages ? pages :page}&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", customer_name lk " + filter : data ? ", customer_name lk "+ data : ""}&${param}`,
      token)
    setListData(res?.data?.payload?.data);
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
      setDropdown(selectOption(currentDepot, option, "value"));
    
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setInitiate(init?.data?.payload?.data);
    setListData(res?.data?.payload?.data);
    setLoad(false)
  }
  };

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page,limit,filter, depot,depotName]);

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      console.log("sini g");
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleEdit = (id) => {
    navigate(ROUTES.ORDER_REQUEST.EDIT, { state: id });
  };

  const handleAdd = (id) => {
    navigate(ROUTES.ORDER_REQUEST.ADD, { state: depot ? depot : depot1 });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.GROMART_ORDER.DETAIL, { state: id });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const checkOne = (event, result) => {
    let value = event.target.checked;
    // console.log("valchk", value, result);
    let order_id = result.order_id;
    let search = _.find(listData, (el) => el.order_id == order_id);
    let findIndex = _.findIndex(listData, (el) => el.order_id == order_id);
    let data = _.some(dataCheck, search);
    if (data) {
      let checkedFalse = [...listData];
      checkedFalse[findIndex] = {
        ...checkedFalse[findIndex],
        checked: false,
      };
      _.remove(dataCheck, search);
      setIsChecked(false);
      setListData(checkedFalse);
      if(dataCheck?.length>1){
        
        setMessage2(dataCheck.length +" Order")
      }else{
        // setMessage2(dataCheck.length +" Order")
        setMessage2(result?.si_group+ " - " +result?.customer_name)
      }
      console.log("datacheck", dataCheck);
    } else {
      let checkedTrue = [...listData];
      checkedTrue[findIndex] = {
        ...checkedTrue[findIndex],
        checked: true,
      };
      _.pull(dataCheck, search);
      dataCheck.push(checkedTrue[findIndex]);
      setListData(checkedTrue);
      if (dataCheck.length === 10) {
        setIsChecked(true);
      }
      if(dataCheck?.length>1){
        
        setMessage2(dataCheck.length +" Order")
      }else{
        // setMessage2(dataCheck.length +" Order")
        setMessage2(result?.si_group+ " - " +result?.customer_name)
      }
    }
    if(dataCheck?.length>1){
        
      setMessage2(dataCheck.length +" Order")
    }else{
      // setMessage2(dataCheck.length +" Order")
      setMessage2(result?.si_group+ " - " +result?.customer_name)
    }
  };

  const dataSource = listData
    ? listData.map((result) => ({
      checkbox: (
        <div className={style.selectOptionContainer}>
          <Checkbox
            onChange={(v) => checkOne(v, result)}
            checked={result.checked}
            disabled={result.status !=="Waiting For Approval"}
            // dataCheck?.map((el) => el.id
            // delivery_associate_id
            // className="mr-2"
            // checked={dataSent?.find(
            //   (permission) => permission === el.code + ":update"
            // )}
            // onChange={(event) =>
            //   onChecked(event, el.code, "update")
            // }
          />
        </div>
      ),
      si_group: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.si_group}
        </span>
      ),
        customer_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.customer_name}
          </span>
        ),
        // customer_phone: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.customer_phone}
        //   </span>
        // ),
        total_sales_invoice: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.total_sales_invoice} SI
          </span>
        ),
        // total_weight: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.total_weight}
        //   </span>
        // ),
        // total_volume: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.total_volume}
        //     </span>
        // ),
        delivery_type: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.delivery_type}
            </span>
        ),
        planned_delivery_time: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.planned_delivery_time}
            </span>
        ),
        arrived_at: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.arrived_at_depot}
            </span>
        ),
        delivery_status: (
          <>
          {
            result?.delivery_status === "On Time" ?
            <div className="bg-[#dbffcf] w-20 px-2 rounded-3xl">
          <p className=" font-roboto-medium font-normal text-[#57C22D]"> {result?.delivery_status} </p>
        </div>
        :
        <div className="bg-[#ffcfcf] flex px-2 rounded-3xl">
          <p className=" font-roboto-medium text-lg font-normal text-[#FF0000]"> {result?.delivery_status?.split("(")[0]} </p>
          <p className=" font-roboto font-normal text-lg text-[#FF0000]"> {" ("+result?.delivery_status?.split("(")[1]} </p>
        </div>
          }
        </>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            {/* {result?.status} */}
            <img src={result?.status === "Approved" ? ApproveIcon : result?.status === "Rejected" ? RejectedIcon : WaitApproveIcon} alt="status"/>
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            {/* <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip> */}
            {/* <Tooltip title={t("Delete")} color="#CF0000">
              <button onClick={result?.status === "New" ? () => setModal(result) : ""}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip> */}

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.id, result?.updated_at)}
                onClick={() => handleDetail(result?.order_id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

    const doSort = async (sort) => {
      setSorting(sort);
    
      if (sort) {
      setSorting(sort);
        // fetchData();
        
      fetchData(data, sort);
        // this.setState({ loading: true });
        // await this.setState(
        //   {
        //     orderby: `${code+" "+sort}`,
        //     pageProductivitySalesman:1,
        //   }
        // )
      }
    };

  const ListColumn = [
    {
      width: 50,
      title: <div className={style.selectOptionContainer}></div>,
      dataIndex: "checkbox",
      key: "checkbox",
      render: (checkbox) => <span>{checkbox}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
        {t("SI Group")}
      </span>
      ),
      dataIndex: "si_group",
      key: "si_group",
      render: (si_group) => <span>{si_group}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
        {t("Customer Name")}
      </span>
      ),
      dataIndex: "customer_name",
      key: "customer_name",
      render: (customer_name) => <span>{customer_name}</span>,
    },

    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Customer Phone")}
    //     </span>
    //   ),
    //   dataIndex: "customer_phone",
    //   key: "customer_phone",
    //   render: (customer_phone) => <span>{customer_phone}</span>,
    // },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Total SI")}
        </span>
      ),
      dataIndex: "total_sales_invoice",
      key: "total_sales_invoice",
      render: (total_sales_invoice) => <span>{total_sales_invoice}</span>,
    },
    
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Delivery Type")}
        </span>
      ),
      dataIndex: "delivery_type",
      key: "delivery_type",
      render: (delivery_type) => <span>{delivery_type}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Planned Delivery Time")}
        </span>
      ),
      dataIndex: "planned_delivery_time",
      key: "planned_delivery_time",
      render: (planned_delivery_time) => <span>{planned_delivery_time}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Arrived At")}
        </span>
      ),
      dataIndex: "arrived_at",
      key: "arrived_at",
      render: (arrived_at) => <span>{arrived_at}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Delivery Status")}
        </span>
      ),
      dataIndex: "delivery_status",
      key: "delivery_status",
      render: (delivery_status) => <span>{delivery_status}</span>,
    },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Total Weight (Kg)")}
    //     </span>
    //   ),
    //   dataIndex: "total_weight",
    //   key: "total_weight",
    //   render: (total_weight) => <span>{total_weight}</span>,
    // },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Total Volume ")} {"(M"}<sup>3</sup>{")"}
    //     </span>
    //   ),
    //   dataIndex: "total_volume",
    //   key: "total_volume",
    //   render: (total_volume) => <span>{total_volume}</span>,
    // },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a,b)=>{
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
    let res = await doGet(`/gromart-order/search?page=1&limit=10&filter=depot_id eq ${depot ? depot : depot1}, customer_name lk ${filters}&${param}`, token);
    setListRecommendation(res?.data?.payload?.data);

    }
  };

  const handleChange = (value, id) => {
    setPage(1)
    setDepot(value);
    setDepotName(value);
    fetchData("",1);
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true)
    setSearchRecommedation(value)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1,10,value)
    } 
  };

  const onSelectRecommendation =(data) => {
    setPage(1)
    setFilter(data)
    fetchData(data, 1)
    setIsfilter(false)
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("",1);
  };

  const options =
  listRecommendation &&
  listRecommendation.map((item) => ({
    value: item.value,
    label: item.value,
  }));

  console.log("listrec", listRecommendation);

  // const options =
  //     listRecommendation &&
  //     listRecommendation?.map((item) => ({
  //       value: item.value,
  //       label: item.value,
  //     }));
  const onStart = async () => {
    let cek = [];
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.order_id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_gromart_order: cek };

    try {
      let tkn = token;
      let res = await doPost(`/gromart-order/approve?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Approve");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };

  const onEnd = async () => {
    let cek = [];
    console.log("isi datacheck", dataCheck);
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.order_id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_gromart_order: cek };
console.log("list trip", list_trip);
    try {
      let tkn = token;
      let res = await doPost(`/gromart-order/reject?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      setMessages("Success Reject");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setEndOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setEndOpen(false);
      }
    }
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setEndOpen(false);
    setMessages("");
    setDataCheck([]);
    fetchData();
    setMessage2("")
  };
  
  return (
    <>
          <ModalStartEndTrip
        visible={startOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to approve`}
        title={dataCheck.length >1 ? message2 :"Approve Order?"}
        titles="Approve"
        message2={message2+"?"}
        onClick={() => onStart()}
        action={() => setStartOpen(false)}
      />
      <ModalStartEndTrip
        visible={endOpen}
        styles={" w-[200px] ml-[-20px]"}
        message2={message2+"?"}
        message={`Are you sure want to reject`}
        title={dataCheck.length >1 ? message2 :"Reject Order?"}
        titles="Reject"
        onClick={() => onEnd()}
        action={() => setEndOpen(false)}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <Delete
        data={data.updated_at}
        id={data.order_id}
        delete={showDelete}
        title={data?.customer_name}
        url={"order"}
        action={() => setShowDelete(false)}
        refresh={()=>fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>GroMart Order</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Gromart Order")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex">
         <AutoComplete
                 options={ options}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search Customer Name")}
                className="w-[350px] h-[47px]"
                height={47}
                width={350}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                // options={options}
                value={searchRecommendation}
                // onChange={(value) => onSearchRecommendation(value)}
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[200px]"}
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
              >
              {!loading
                  ? dropdown
                  : [...dropdown]}
              </Select>
            <SecondaryButton
              text={t("Reject Order")}
              disabled={!dataCheck?.length}
              action={() => setEndOpen(true)}
              
              styles="ml-3"
              // action={() => setPage(1)}
            />
              <PrimaryButton
              text={t("Approve Order")}
              styles="ml-3 mr-3"
              disabled={!dataCheck?.length}
              action={() => setStartOpen(true)}
            />
            </div>

          {/* <Link to={ROUTES.ORDER_REQUEST.ADD}> */}
            {/* <PrimaryButton
              text={t("Add Order Request")}
              prefixIcon={<AddIcon />}
              action={() => handleAdd()}/> */}
          {/* </Link> */}
        </div>

        <Alert
      message="Informational"
      description="If you select two differents orders for the same Customer, they will be grouped into a single order request."
      type="info"
      showIcon
      closable
    />
        {
  !load ?
        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        : "...loading"}
      </div>
    </>
  );
};

export default GromartOrderRequestList;
